/* eslint-disable no-useless-escape */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import moment from 'moment'
import { toast } from 'react-toastify'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { config } from '@fortawesome/fontawesome-svg-core'
import debounce from 'lodash.debounce'
import uniq from 'lodash.uniq'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import DownloadIcon from '@mui/icons-material/Download'
import { LoadingButton } from '@mui/lab'
import { TOAST_DEFAULT_CONFIG } from '../../constants/toast'
import {
  NO_GROUP_FILTER_OPTION,
  productAnalysis,
  productAnalysisCSV,
  productAnalysisGroupings,
  productUpdateStatus,
  selectIsStatusUpdateLoading,
  selectIsproductAnalysisCSVDataLoading,
  selectProductAnalysisDataLoading,
  selectProductGroupingsOptions,
  selectProductGroupingsOptionsLoaded,
} from '../../store/slice/product'
import { accountInfo, userData } from '../../store/slice/user'
import { setPage } from '../../store/slice/page'
import { TABLE_VIEW_VARIANT } from './utils/TABLE_TYPE'
import {
  defaultColConfig,
  initStoredFilters,
  selectAcosRange,
  selectColConfig,
  selectFilters,
  selectIsFiltersChange,
  selectIsFiltersInited,
  selectNetProfitRange,
  selectTacosRange,
  setAcosRange,
  setColConfig,
  setDefaultFilters,
  setFilters,
  setNetProfitRange,
  setTacosRange,
  defaultFilters,
  initColConfig,
  selectTotalProfitRange,
  setTotalProfitRange,
} from '../../store/slice/cockpit'

import PageWrapper from '../../containers/PageWrapper'
import PageHeadline from '../../components/PageHeadline'
import CustomSelect from '../../components/Form/CustomSelect'
import CustomSlider from '../../components/Form/CustomSlider'
import CustomDataPicker from '../../components/Form/CustomDataPicker'
import usePrompt from '../../utils/hooks/preventPage'
import SearchBar from '../../components/Form/SearchBar'
import '@fortawesome/fontawesome-svg-core/styles.css'

import { buildTable } from './utils/buildTable'
import { getAccosColor, getNetProfitColor, getTaccosColor } from './utils/getAccosColor'
import KeywordButton from './KeywordButton'
import { fontAwesomeIcons } from './utils/tableIcons'
import HtmlTooltip from '../../components/HtmlTooltip'
import ProductManageModal from '../../components/ProductManageModal'
import { COCKPIT_TABLE_CHANGABLE_FIELDS, changeProductField } from './utils/editProduct'
import BoostSlider from '../../components/Form/CustomBoostSlider'
import ColumnVisibility from './ColumnVisibility'
import { getAccountID } from '../../utils/auth'
import { downloadURI } from '../../utils/download-file'
import { columnsToHide, formatValue, formatZeroValueToPercent } from './utils/rowManipulations'
import { alphaNumSortDashLast, numericSortDashLast, productReturnsSort, stripLeadingLetters } from './utils/rowSort'
import useStyles from './styles'
import MemoSwitch from './MemoSwitch'

config.autoAddCss = false

const DEFAULT_VAL_NONE = 'filter-no-group'
const FILTER_SELECT_OPTIONS = [
  {
    value: 0,
    label: 'Products: All (incl. historical)',
  },
  {
    value: 1,
    label: 'Products: Available for purchase on platform',
  },
]

const CockpitPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const user = useSelector(userData)
  const accountInfoData = useSelector(accountInfo)

  const filtersOptions = useSelector(selectProductGroupingsOptions)
  const isProductGroupingsOptionsLoaded = useSelector(selectProductGroupingsOptionsLoaded)
  const isProductsDataLoading = useSelector(selectProductAnalysisDataLoading)
  const isProductsCSVDataLoading = useSelector(selectIsproductAnalysisCSVDataLoading)
  const isProductsUpdateStatusLoading = useSelector(selectIsStatusUpdateLoading)

  const isFiltersInitialized = useSelector(selectIsFiltersInited)
  const storedFilters = useSelector(selectFilters)
  const [selectedFilters, setSelectedFilters] = useState({
    ...defaultFilters,
  })
  const selectedAcosRange = useSelector(selectAcosRange)
  const selectedTacosRange = useSelector(selectTacosRange)
  const selectedNetProfitRange = useSelector(selectNetProfitRange)
  const selectedTotalProfitRange = useSelector(selectTotalProfitRange)

  const selectIsFilterChanged = useSelector(selectIsFiltersChange)
  const storedColConfig = useSelector(selectColConfig)

  const [modifyTableProducts, setModifyTableProducts] = useState(null)

  const [isTableLoading, setIsTableLoading] = useState(true)
  const [tableType, setTableType] = useState()
  const [tableData, setTableData] = useState([])
  const [tableTotalHeaderData, setTableTotalHeaderData] = useState([])
  const [csvDataLoading, setCsvDataLoading] = useState(false)

  // request control refs
  const requestSeqRef = useRef(0)
  const pendingRequestRef = useRef(null)

  const memoTableData = useMemo(() => tableData, [tableData])

  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false)

  const [keywordModal, setKeywordModal] = useState({
    isOpen: false,
    data: null,
  })

  const columnsToHideProp = useMemo(
    () => columnsToHide(storedColConfig, getAccountID, accountInfoData),
    [storedColConfig, user, accountInfoData, selectedFilters]
  )

  const mainColTitle = useMemo(() => {
    const label = 'All Channels'

    if (!selectedFilters) return
    if (selectedFilters.channel === 0 && selectedFilters.groupBy === NO_GROUP_FILTER_OPTION.value) return 'All Products'
    if (selectedFilters.channel === -1 && selectedFilters.groupBy === NO_GROUP_FILTER_OPTION.value)
      return 'All Channels'
    if (selectedFilters.channel !== 0 && selectedFilters.groupBy) {
      const channel = filtersOptions?.channels?.find((item) => item.value === selectedFilters.channel)?.label
      if (selectedFilters.groupBy === NO_GROUP_FILTER_OPTION.value) {
        return `${channel ? `${channel} ` : ''} All Products`
      }

      const filterText = `Grouping (based on '${selectedFilters.groupBy}')${channel ? `<br />& ${channel}` : ''}`
      return filterText
    }
    if (selectedFilters.groupBy !== NO_GROUP_FILTER_OPTION.value) return `All ${selectedFilters.groupBy}`

    return label
  }, [selectedFilters, filtersOptions])

  const prepareFiltersToRequest = useCallback(() => {
    const prepared = {
      restrictToChannel: selectedFilters.channel,
      dateFrom: selectedFilters.dateFrom,
      dateTo: selectedFilters.dateTo,
      filterBy: selectedFilters.filterBy,
      showOnlyActive: selectedFilters.showOnlyActive,
    }

    if (selectedFilters.groupBy !== NO_GROUP_FILTER_OPTION.value) {
      prepared.groupBy = selectedFilters.groupBy
    }

    return prepared
  }, [selectedFilters])

  const makeTableData = (res) => {
    try {
      const { tableData: tableDataBuilded, tableType: tableTypeBuilded } = buildTable(res, selectedAcosRange)
      if (tableDataBuilded?.row) {
        setTableData(tableDataBuilded.row)
      }
      if (tableDataBuilded?.totalData) {
        setTableTotalHeaderData(tableDataBuilded.totalData)
      }
      setTableType(tableTypeBuilded)
      setIsTableLoading(false)
    } catch (err) {
      setIsTableLoading(false)
    }
  }

  const setProductChanged = (path, newValue, fieldName) => {
    const { data, onlyChangedItems, activeCountTotal, activeCountTotalItemsTotal } = changeProductField({
      data: tableData,
      path,
      newValue,
      tableView: tableType,
      fieldName,
    })

    setTableData(data)
    setTableTotalHeaderData((prev) => ({
      ...prev,
      activeCount: activeCountTotal,
      activeProducts: activeCountTotalItemsTotal,
    }))
    // TODO: need to optimize the getting of changed elements so that you don't need to constantly extract and check all products, every time a single product is changed
    setModifyTableProducts(onlyChangedItems)
  }

  const handleBoostChange = debounce((path, newValue, fieldName) => {
    setProductChanged(path, newValue, fieldName)
  }, 300)

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: mainColTitle,
        Header: (
          <HtmlTooltip title={'Product grouping based on the above "Group by" and "Channel" selectors.'}>
            <div className={`${classes.header_col} ${classes.left}`}>
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: mainColTitle,
                }}
              />
              <ColumnVisibility
                columns={storedColConfig[getAccountID()] || defaultColConfig}
                additionalColumns={accountInfoData?.additionalColumns}
                onChange={(e) => {
                  dispatch(
                    setColConfig({
                      ...storedColConfig,
                      [getAccountID()]: e,
                    })
                  )
                }}
              />
            </div>
          </HtmlTooltip>
        ),
        enableSorting: selectedFilters?.groupBy === 'productReturns',
        sortingFn: productReturnsSort,
        minSize: 360,
        size: 360,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <div title={renderedCellValue} className={classes.name_td}>
              {selectedFilters?.groupBy === 'productReturns'
                ? stripLeadingLetters(renderedCellValue)
                : renderedCellValue}
            </div>
            {row.original.productID && (
              <HtmlTooltip
                title={
                  !row.original.presentOnPlatform
                    ? 'Campaigns on platform have not been created yet, please try again tomorrow.'
                    : ''
                }
              >
                {selectedFilters.channel !== 0 && (
                  <div>
                    <KeywordButton
                      disabled={!row.original.presentOnPlatform}
                      clickHandler={() =>
                        setKeywordModal({
                          isOpen: true,
                          data: row.original,
                        })
                      }
                    />
                  </div>
                )}
              </HtmlTooltip>
            )}
          </>
        ),
      },
      {
        accessorKey: 'ean',
        header: 'EAN',
        Header: (
          <HtmlTooltip title="European Article Number: Unique barcode identifier used to distinguish products internationally in retail and logistics.">
            <div className={`${classes.header_col} ${classes.text_left}`}>
              <span>EAN</span>
            </div>
          </HtmlTooltip>
        ),
        enableSorting: true,
        sortingFn: numericSortDashLast,
        Cell: ({ renderedCellValue, row }) =>
          (!row.depth && tableType !== TABLE_VIEW_VARIANT.SIMPLE) || row.subRows?.length ? '' : renderedCellValue,
        size: 141,
        minSize: 141,
      },
      {
        accessorKey: 'asin',
        header: 'ASIN',
        Header: (
          <HtmlTooltip title="Amazon Standard Identification Number: Unique identifier assigned by Amazon to each product listed on its marketplace.">
            <div className={classes.header_col}>
              <span>ASIN</span>
              <span>{tableTotalHeaderData.asin}</span>
            </div>
          </HtmlTooltip>
        ),
        enableSorting: true,
        sortingFn: alphaNumSortDashLast,
        size: 131,
        minSize: 131,
      },
      {
        accessorKey: 'customerID',
        header: 'Custom ID',
        Header: (
          <HtmlTooltip title="Product identification assigned by the seller. Typically this is the SKU (Stock Keeping Unit): A unique code used by retailers to track individual products, variations, and inventory internally.">
            <div className={classes.header_col}>
              <span>Custom ID</span>
              <span>{tableTotalHeaderData.customerID}</span>
            </div>
          </HtmlTooltip>
        ),
        enableSorting: true,
        sortingFn: alphaNumSortDashLast,
        size: 181,
        minSize: 181,
      },
      {
        accessorKey: 'presentInChannels_count',
        header: 'Channels',
        Header: (
          <HtmlTooltip title="The number of channels that this product is sold through.">
            <div className={classes.header_col}>
              <span>Channels</span>
              <span>{tableTotalHeaderData.presentInChannels_count}</span>
            </div>
          </HtmlTooltip>
        ),
        title: undefined,
        enableSorting: false,
        size: 88,
        minSize: 88,
      },
      {
        accessorKey: 'products',
        header: 'Products',
        Header: (
          <HtmlTooltip title="Number of products in grouping">
            <div className={classes.header_col}>
              <span>Products</span>
              <span>{tableTotalHeaderData.products}</span>
            </div>
          </HtmlTooltip>
        ),
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (row.depth === 0 ? formatValue(renderedCellValue, 0) : ''),
        size: 87,
        minSize: 87,
      },
      {
        accessorKey: 'activeEdited',
        enableSorting: true,
        header: 'Active',
        sortingFn: (rowA, rowB, columnId) => {
          const valueA = rowA.getValue(columnId) === -1 ? 0.5 : Boolean(rowA.getValue(columnId))
          const valueB = rowB.getValue(columnId) === -1 ? 0.5 : Boolean(rowB.getValue(columnId))
          if (valueA > valueB) return 1
          if (valueA < valueB) return -1
          return 0
        },
        Header: (
          <HtmlTooltip title="Shows whether advertising for the product is active. Updates are processed overnight and go live the next day.">
            <div className={classes.header_col}>
              <span>Active</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) =>
          row.activeEdited !== 'none' ? (
            <MemoSwitch
              active={renderedCellValue}
              onChangeHandler={(e) => {
                setProductChanged(row.id, e, COCKPIT_TABLE_CHANGABLE_FIELDS.activeEdited)
              }}
            />
          ) : (
            ''
          ),
        size: 90,
        minSize: 90,
      },
      {
        accessorKey: 'activeCount',
        enableSorting: true,
        header: 'Active (count)',
        sortingFn: 'alphanumeric',
        Header: () => (
          <HtmlTooltip title="Indicates whether the advertisement for the product is active.">
            <div className={classes.header_col}>
              <span>Active (count)</span>
              <span>{uniq(tableTotalHeaderData.activeProducts?.map((item) => item.ean))?.length}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => (
          <span className={classes.active_count}>
            {row.original.subRows.length
              ? tableType === TABLE_VIEW_VARIANT.DOUBLE_NESTED && row.original.parentPos === -1
                ? uniq(row.original.activeProducts?.map((item) => item.ean))?.length
                : tableType === TABLE_VIEW_VARIANT.ONE_NESTED && !row.original.productID
                ? uniq(row.original.activeProducts?.map((item) => item.ean))?.length
                : row.original.activeCount
              : false}
          </span>
        ),
        size: 135,
        minSize: 135,
      },
      {
        accessorKey: 'boostEdited',
        header: 'Boosting',
        Header: (
          <HtmlTooltip
            title={
              <div>
                <span>
                  Increase or reduce advertising pressure for a product; one step equals roughly a 3% Target ACoS shift.
                </span>
                <br />
                <br />
                <span>
                  Explanation: The default Target ACoS for all products is defined in “Channel Settings.” From that
                  baseline (position “0” below), the Boosting slider lets you raise or lower the Target ACoS per
                  product.
                </span>
              </div>
            }
          >
            <div className={`${classes.header_col} ${classes.align_center}`}>
              <span>Boosting</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) =>
          selectedFilters?.channel !== 0 && (
            <BoostSlider
              hideLabel={row.original.productID}
              value={renderedCellValue}
              onChange={(e) => handleBoostChange(row.id, e, COCKPIT_TABLE_CHANGABLE_FIELDS.boostEdited)}
              showRange={!row.original.productID}
              rangeMin={row.original.minBoost}
              rangeMax={row.original.maxBoost}
            />
          ),
        enableSorting: true,
        sortingFn: numericSortDashLast,
        size: 161,
        minSize: 161,
      },
      {
        accessorKey: 'performanceClass',
        header: 'Performance class',
        Header: (
          <div className={`${classes.header_col} ${classes.text_left}`}>
            <span>Performance class</span>
          </div>
        ),
        enableSorting: true,
        Cell: ({ renderedCellValue, row }) => (
          <div className={`${classes.header_col} ${classes.text_left}`}>
            <span>{renderedCellValue}</span>
          </div>
        ),
        size: 180,
        minSize: 180,
      },
      // TODO: temporary hide NSL23-199 feature
      // {
      //   accessorKey: 'averageOrganicRank',
      //   header: 'AOR',
      //   Header: (
      //     <HtmlTooltip title="Average Organic Rank (%). This is the weighted average organic rank of the keywords selected for organic rank management for the product.">
      //       <div className={`${classes.header_col} ${classes.text_center}`}>
      //         <span>AOR</span>
      //         <span>{tableTotalHeaderData.averageOrganicRank}</span>
      //       </div>
      //     </HtmlTooltip>
      //   ),
      //   enableSorting: true,
      //   Cell: ({ renderedCellValue, row }) => (
      //     <div className={`${classes.header_col} ${classes.text_center}`}>
      //       <span>{formatValue(renderedCellValue, 1)}</span>
      //     </div>
      //   ),
      //   size: 120,
      //   minSize: 120,
      // },
      {
        accessorKey: 'acos',
        header: 'ACoS (%)',
        Header: (
          <HtmlTooltip
            title={
              <div>
                <span>
                  Advertising Cost of Sales (%). ACoS is the percentage of ad spend relative to advertising sales. The
                  achieved ACoS may vary depending on product competitiveness, market conditions, and individual
                  DeepCliq settings.
                </span>
                <br />
                <br />
                <span>Formula: ACoS = (Advertising Spend / Advertising Sales) x 100</span>
              </div>
            }
          >
            <div className={`${classes.header_col} ${classes.text_center}`}>
              <span>ACoS (%)</span>
              <span>{formatValue(tableTotalHeaderData.acos, 1)}</span>
            </div>
          </HtmlTooltip>
        ),
        sortingFn: numericSortDashLast,
        size: 120,
        minSize: 120,
        Cell: ({ renderedCellValue, row }) => (
          <span
            className={`${classes.td_acos} ${classes.text_center} ${getAccosColor(
              +renderedCellValue,
              selectedAcosRange?.[0],
              selectedAcosRange?.[1]
            )}`}
          >
            {formatValue(renderedCellValue, 0)}
          </span>
        ),
      },
      {
        accessorKey: 'tacos',
        header: 'TACoS (%)',
        Header: (
          <HtmlTooltip
            title={
              <div>
                <span>
                  Total Average Cost of Sales (%). Similar metric to ACoS, but compared to ACoS it also includes organic
                  sales in addition to advertising sales.
                </span>
                <br />
                <br />
                <span>Formula: TACoS = (Advertising Spend / (Advertising Sales + Organic Sales)) x 100</span>
              </div>
            }
          >
            <div className={`${classes.header_col} ${classes.text_center}`}>
              <span>TACoS (%)</span>
              <span>{formatValue(tableTotalHeaderData.tacos, 1)}</span>
            </div>
          </HtmlTooltip>
        ),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
        Cell: ({ renderedCellValue, row }) => (
          <span
            className={`${classes.td_acos} ${classes.text_center} ${getTaccosColor(
              +renderedCellValue,
              selectedTacosRange?.[0],
              selectedTacosRange?.[1]
            )}`}
          >
            {formatValue(renderedCellValue, 0)}
          </span>
        ),
      },
      {
        accessorKey: 'profit',
        header: 'Ad profit (%)',
        Header: (
          <HtmlTooltip
            title={
              <div>
                <span>
                  Estimated advertising profit. Formula: (Ad profit) = (Advertising Sales) - (COGS) - (Shipping Costs) -
                  (Platform Commission) - (Estimated Return Costs) - (Advertising Spend)
                </span>
                <br />
                <br />
                <span>All values are excl. VAT.</span>
              </div>
            }
          >
            <div className={`${classes.header_col} ${classes.text_center}`}>
              <span>Ad profit (%)</span>
              <span>{formatValue(tableTotalHeaderData.profit, 1)}</span>
            </div>
          </HtmlTooltip>
        ),
        sortingFn: numericSortDashLast,
        size: 130,
        minSize: 130,
        Cell: ({ renderedCellValue, row }) => (
          <span
            className={`${classes.td_acos} ${classes.text_center} ${getNetProfitColor(
              +renderedCellValue,
              selectedNetProfitRange?.[0],
              selectedNetProfitRange?.[1]
            )}`}
          >
            {formatValue(renderedCellValue, 0)}
          </span>
        ),
      },
      {
        accessorKey: 'totalNetProportion',
        header: 'Total profit (%)',
        Header: (
          <div className={`${classes.header_col} ${classes.text_center}`}>
            <span>Total profit (%)</span>
            <span>{formatValue(tableTotalHeaderData.totalNetProportion, 1)}</span>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => (
          <span
            className={`${classes.td_acos} ${classes.text_center} ${getNetProfitColor(
              +renderedCellValue,
              selectedTotalProfitRange?.[0],
              selectedTotalProfitRange?.[1]
            )}`}
          >
            {formatValue(renderedCellValue, 0)}
          </span>
        ),
        sortingFn: numericSortDashLast,
        size: 145,
        minSize: 145,
      },
      {
        accessorKey: 'totalSales',
        header: 'Total sales (€)',
        Header: (
          <HtmlTooltip title="Total product revenue (advertising plus organic sales)">
            <div className={classes.header_col}>
              <span>Total sales (€)</span>
              <span>{tableTotalHeaderData.totalSales}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue),
        sortingFn: numericSortDashLast,
        size: 150,
        minSize: 150,
      },
      {
        accessorKey: 'sales',
        header: 'Ad sales (€)',
        Header: (
          <div className={classes.header_col}>
            <span>Ad sales (€)</span>
            <span>{tableTotalHeaderData.sales}</span>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue),
        sortingFn: numericSortDashLast,
        size: 135,
        minSize: 135,
      },
      {
        accessorKey: 'adProfitAbsolute',
        header: 'Ad profit (€)',
        Header: (
          <div className={classes.header_col}>
            <span>Ad profit (€)</span>
            <span>{tableTotalHeaderData.adProfitAbsolute}</span>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
      },
      {
        accessorKey: 'profitAbsolute',
        header: 'Total profit (€)',
        Header: (
          <div className={classes.header_col}>
            <span>Total profit (€)</span>
            <span>{tableTotalHeaderData.profitAbsolute}</span>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue),
        sortingFn: numericSortDashLast,
        size: 135,
        minSize: 135,
      },
      {
        accessorKey: 'cost',
        header: 'Ad spend (€)',
        Header: (
          <HtmlTooltip title="Advertising spend on platform">
            <div className={classes.header_col}>
              <span>Ad spend (€)</span>
              <span>{tableTotalHeaderData.cost}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
      },
      {
        accessorKey: 'returnRate',
        header: 'Return rate (%)',
        Header: (
          <HtmlTooltip
            title={
              <div>
                <span>
                  Percentage of product returned, calculated over total product sales (advertising and organic) and over
                  the currently selected time period.
                </span>
                <br />
                <br />
                <span>Formula = (Number of product returns) / (Number of total product sales)</span>
              </div>
            }
          >
            <div className={classes.header_col}>
              <span>Return rate (%)</span>
              <span>{tableTotalHeaderData.returnRate}</span>
            </div>
          </HtmlTooltip>
        ),
        sortingFn: numericSortDashLast,
        size: 160,
        minSize: 160,
      },
      {
        accessorKey: 'conversions',
        header: 'Conversions',
        Header: (
          <HtmlTooltip title="Number of advertising sales of a product, or group of products.">
            <div className={classes.header_col}>
              <span>Conversions</span>
              <span>{tableTotalHeaderData.conversions}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue, 0),
        sortingFn: numericSortDashLast,
        size: 135,
        minSize: 135,
      },
      {
        accessorKey: 'conversionRate',
        header: 'Conversion rate',
        Header: (
          <HtmlTooltip title="Conversion rate (%)">
            <div className={classes.header_col}>
              <span>CR (%)</span>
              <span>{formatZeroValueToPercent(tableTotalHeaderData.conversionRate, 1)}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatZeroValueToPercent(renderedCellValue, 1),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
      },
      {
        accessorKey: 'clicks',
        header: 'Clicks',
        Header: (
          <HtmlTooltip title="Number of clicks that the product, or group of products, received.">
            <div className={classes.header_col}>
              <span>Clicks</span>
              <span>{tableTotalHeaderData.clicks}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue, 0),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
      },
      {
        accessorKey: 'clickThroughRate',
        header: 'Click-through rate',
        Header: (
          <HtmlTooltip title="Click-through rate (%)">
            <div className={classes.header_col}>
              <span>CTR (%)</span>
              <span>{formatZeroValueToPercent(tableTotalHeaderData.clickThroughRate, 1)}</span>
            </div>
          </HtmlTooltip>
        ),
        Cell: ({ renderedCellValue, row }) => formatZeroValueToPercent(renderedCellValue, 1),
        sortingFn: numericSortDashLast,
        size: 125,
        minSize: 125,
      },
      {
        accessorKey: 'impressions',
        header: 'Impressions',
        Header: (
          <div className={classes.header_col}>
            <span>Impressions</span>
            <span>{tableTotalHeaderData.impressions}</span>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => formatValue(renderedCellValue, 0),
        sortingFn: numericSortDashLast,
        size: 145,
        minSize: 145,
      },
      {
        accessorKey: 'error',
        header: 'Error',
        Header: (
          <div className={classes.header_col}>
            <span>Error</span>
          </div>
        ),
        enableSorting: true,
        size: 95,
        minSize: 95,
      },
    ],
    [
      memoTableData,
      selectedAcosRange,
      selectedTacosRange,
      selectedNetProfitRange,
      selectedTotalProfitRange,
      mainColTitle,
      selectedFilters,
      columnsToHideProp,
      user,
    ]
  )

  const table = useMaterialReactTable({
    columns,
    data: memoTableData,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableExpandAll: true,
    enableExpanding: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableRowVirtualization: true,
    muiTableBodyCellProps: ({ cell }) => {
      const { row } = cell
      const isTopRow = !row.original.productID
      const isExpanded = (row.getIsExpanded() && row.subRows?.length) || row.depth

      const isSubRow = row.depth

      return {
        sx: {
          fontSize: isTopRow ? '16px ' : '14px ',
          fontWeight: isTopRow ? '600 ' : '300 ',
          background: isExpanded ? '#F8F8F8;' : '#ffffff',
          '&:hover': {
            background: isExpanded ? 'blue' : 'rgb(242, 242, 242)',
          },
          '&:not(:first-child)': {
            padding: !isSubRow ? '12px' : '0px 12px',
          },
          '&:first-child': {
            paddingLeft: !isSubRow ? '12px' : row.depth === 1 ? '24px' : '12px',
            '& *': {
              opacity: row.depth > 1 ? 0 : row.depth <= 1 && !row.subRows.length ? 0.7 : 1,
            },
          },
          '&:nth-child(2)': {
            paddingLeft: isSubRow ? '30px' : '12px',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '15px',
          },
          borderTop: isSubRow ? 0 : '1px solid rgba(196, 196, 196, 0.25)',
        },
      }
    },
    muiCircularProgressProps: {
      color: 'secondary',
      thickness: 5,
      size: 55,
    },
    muiSkeletonProps: {
      animation: 'pulse',
      height: 28,
    },
    enableColumnResizing: true,
    icons: fontAwesomeIcons,
    enableTopToolbar: false,
    filterFromLeafRows: true,
    initialState: {
      expanded: true,
      pagination: {
        pageSize: 10000000,
      },
    },
    muiPaginationProps: {
      showRowsPerPage: false,
      shape: 'rounded',
    },
    paginationDisplayMode: 'pages',
    state: {
      showLoadingOverlay: isTableLoading,
      columnVisibility: {
        ...columnsToHideProp,
        activeEdited: selectedFilters?.channel !== 0,
        boostEdited: selectedFilters?.channel !== 0,
        activeCount: selectedFilters?.channel !== 0 ? Boolean(columnsToHideProp.activeCount) : false,
        presentInChannels_count: selectedFilters?.channel === 0,
      },
    },
    paginateExpandedRows: false,
  })

  const requestTableData = useCallback(
    ({ withLoading = true } = {}) => {
      if (!user.accountID) return

      if (withLoading) setIsTableLoading(true)

      // Abort previous request if still pending
      if (pendingRequestRef.current && typeof pendingRequestRef.current.abort === 'function') {
        try {
          pendingRequestRef.current.abort()
        } catch (e) {
          // ignore
        }
      }

      const currentSeq = requestSeqRef.current + 1
      requestSeqRef.current = currentSeq

      const promise = dispatch(
        productAnalysis({
          id: user.accountID,
          params: {
            ...prepareFiltersToRequest(),
          },
        })
      )

      pendingRequestRef.current = promise

      promise
        .unwrap()
        .then((res) => {
          // ignore stale responses
          if (currentSeq !== requestSeqRef.current) return
          setModifyTableProducts(null)
          makeTableData(res)
        })
        .catch((err) => {
          // ignore stale/aborted errors
          if (currentSeq !== requestSeqRef.current) return
          if (err && (err.name === 'AbortError' || err.code === 'ERR_CANCELED')) return
          toast.error(err, TOAST_DEFAULT_CONFIG)
          setIsTableLoading(false)
        })
    },
    [dispatch, user?.accountID, prepareFiltersToRequest]
  )

  const requestTableCSVData = () => {
    dispatch(
      productAnalysisCSV({
        id: user.accountID,
        params: {
          ...prepareFiltersToRequest(),
        },
      })
    )
      .unwrap()
      .then((res) => {
        const blob = new Blob(
          [
            new Uint8Array([0xef, 0xbb, 0xbf]), // UTF-8 BOM
            res,
          ],
          { type: 'application/csv;charset=utf-8' }
        )
        const u = window.URL.createObjectURL(blob)
        downloadURI(u, 'CSV.csv')
        window.URL.revokeObjectURL(u)
      })
      // eslint-disable-next-line no-console
      .catch((err) => {
        toast.error(err, TOAST_DEFAULT_CONFIG)
      })
  }

  const handleChangeFilter = (e, key) => {
    dispatch(setFilters({ ...selectedFilters, [key]: e, id: getAccountID() }))
  }

  const handleAcosChange = debounce((e) => {
    dispatch(setAcosRange({ value: e, id: getAccountID() }))
  }, 500)

  const handleTacosChange = debounce((e) => {
    dispatch(setTacosRange({ value: e, id: getAccountID() }))
  }, 500)

  const handleNetProfitChange = debounce((e) => {
    dispatch(setNetProfitRange({ value: e, id: getAccountID() }))
  }, 500)

  const handleTotalProfitChange = debounce((e) => {
    dispatch(setTotalProfitRange({ value: e, id: getAccountID() }))
  }, 500)

  const handleDataChange = (value) => {
    dispatch(
      setFilters({
        ...selectedFilters,
        dateFrom: moment(value[0]).format('yyyy-MM-DD'),
        dateTo: moment(value[1]).format('yyyy-MM-DD'),
        id: getAccountID(),
      })
    )
  }

  const handleSave = () => {
    dispatch(
      productUpdateStatus({
        id: user.accountID,
        data: modifyTableProducts.map((item) => ({
          productID: item.productID,
          channelID: item.channelID,
          newActivationStatus: Boolean(item.activeEdited),
          newBoostStatus: item.boostEdited,
        })),
      })
    )
      .unwrap()
      .then(() => {
        // setModifyTableProducts(null)
        requestTableData({ withLoading: false })
        toast.success('Table data update success', TOAST_DEFAULT_CONFIG)
      })
      .catch((err) => {
        toast.error(err, TOAST_DEFAULT_CONFIG)
      })
  }

  usePrompt('Are you sure you want to leave?', modifyTableProducts)

  useEffect(() => {
    if (!modifyTableProducts) return () => {}

    const beforeUnloadCallback = (event) => {
      event.preventDefault()
      // eslint-disable-next-line no-param-reassign
      event.returnValue = 'Are you sure you want to leave?'
      return 'Are you sure you want to leave?'
    }

    window.addEventListener('beforeunload', beforeUnloadCallback)

    return () => {
      window.removeEventListener('beforeunload', beforeUnloadCallback)
    }
  }, [modifyTableProducts])

  useEffect(() => {
    if (user.accountID) {
      if (!isProductGroupingsOptionsLoaded) {
        dispatch(productAnalysisGroupings(user.accountID))
        dispatch(initStoredFilters({ id: getAccountID() }))
      }
      dispatch(initColConfig({ id: getAccountID() }))
    }
  }, [user])

  useEffect(() => {
    if (storedFilters) {
      setSelectedFilters(storedFilters)
    }
  }, [storedFilters])

  useEffect(() => {
    if (!isProductsDataLoading && user?.accountID && isProductGroupingsOptionsLoaded && isFiltersInitialized) {
      if (!selectedFilters?.groupBy) {
        const defaultFind = filtersOptions.groupBy.find((item) => item.value === DEFAULT_VAL_NONE)
        dispatch(setFilters({ ...selectedFilters, groupBy: defaultFind, id: getAccountID() }))
      }
    }
  }, [isFiltersInitialized, isProductGroupingsOptionsLoaded, selectedFilters])

  useEffect(() => {
    if (!selectedFilters) return undefined

    const debounced = debounce(() => {
      requestTableData({ withLoading: true })
    }, 400)

    debounced()

    return () => {
      debounced.cancel()
      if (pendingRequestRef.current && typeof pendingRequestRef.current.abort === 'function') {
        try {
          pendingRequestRef.current.abort()
        } catch (e) {
          // ignore
        }
      }
    }
  }, [selectedFilters, requestTableData])

  useEffect(() => {
    dispatch(setPage('cockpit'))
  }, [])

  return (
    <PageWrapper>
      <Box className={classes.page_wrapper}>
        <PageHeadline isWhite>
          <Box className={`${classes.headline} ${!isHeaderExpanded ? classes.headline_collapsed : ''}`}>
            <Box className={`${classes.headline_row} ${classes.headline_sliders_row}`}>
              <Box className={classes.headline_slider}>
                <CustomSlider
                  label="ACoS"
                  step={0.1}
                  minRange={0}
                  maxRange={50}
                  minValue={selectedAcosRange?.[0]}
                  maxValue={selectedAcosRange?.[1]}
                  onChange={(e) => handleAcosChange(e)}
                />
              </Box>
              <Box className={classes.headline_slider}>
                <CustomSlider
                  label="TACoS"
                  step={0.1}
                  minRange={0}
                  maxRange={25}
                  minValue={selectedTacosRange?.[0]}
                  maxValue={selectedTacosRange?.[1]}
                  onChange={(e) => handleTacosChange(e)}
                />
              </Box>
              <Box className={classes.headline_slider}>
                <CustomSlider
                  label="Ad profit"
                  step={0.1}
                  minRange={-10}
                  maxRange={50}
                  minValue={selectedNetProfitRange?.[0]}
                  maxValue={selectedNetProfitRange?.[1]}
                  onChange={(e) => handleNetProfitChange(e)}
                />
              </Box>
              <Box className={classes.headline_slider}>
                <CustomSlider
                  label="Total profit"
                  step={0.1}
                  minRange={-10}
                  maxRange={50}
                  minValue={selectedTotalProfitRange?.[0]}
                  maxValue={selectedTotalProfitRange?.[1]}
                  onChange={(e) => handleTotalProfitChange(e)}
                />
              </Box>
            </Box>
            <Box className={`${classes.headline_row} ${classes.headline_bottom_row}`}>
              <Box className={classes.headline_filter}>
                <Box className={classes.headline_select}>
                  <CustomSelect
                    label="Channel:"
                    value={selectedFilters?.channel}
                    options={filtersOptions?.channels}
                    onChange={(e) => handleChangeFilter(e, 'channel')}
                  />
                </Box>
                <Box className={classes.headline_select}>
                  <CustomSelect
                    label="Group by:"
                    value={selectedFilters?.groupBy}
                    options={filtersOptions?.groupBy}
                    onChange={(e) => handleChangeFilter(e, 'groupBy')}
                  />
                </Box>
                <Box className={classes.headline_select}>
                  <CustomSelect
                    label="Filter by:"
                    value={selectedFilters?.showOnlyActive}
                    options={FILTER_SELECT_OPTIONS}
                    onChange={(e) => handleChangeFilter(e, 'showOnlyActive')}
                  />
                </Box>
                <Box className={classes.headline_date}>
                  <CustomDataPicker
                    onChange={handleDataChange}
                    initStartRange={selectedFilters?.dateFrom}
                    initEndRange={selectedFilters?.dateTo}
                  />
                </Box>
                <Box className={classes.headline_search}>
                  <SearchBar
                    value={selectedFilters?.filterBy}
                    onSubmit={(e) => handleChangeFilter(e, 'filterBy')}
                    placeholder="Enter your search term"
                  />
                </Box>
              </Box>
              <Box className={classes.headline_save}>
                <Button
                  variant="text"
                  onClick={() => {
                    setIsHeaderExpanded((prev) => !prev)
                  }}
                  className={`${classes.expand_button} ${isHeaderExpanded && classes.expanded}`}
                >
                  <div title={isHeaderExpanded ? 'Collapse' : 'Expand'}>
                    <KeyboardArrowDownIcon />
                  </div>
                </Button>
                <LoadingButton
                  loading={isProductsCSVDataLoading}
                  loadingPosition="start"
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  className={classes.csv_btn}
                  onClick={requestTableCSVData}
                >
                  CSV
                </LoadingButton>
                <Button
                  variant="outlined"
                  onClick={() => {
                    dispatch(setDefaultFilters({ id: getAccountID() }))
                    setModifyTableProducts(null)
                  }}
                  disabled={!selectIsFilterChanged && !modifyTableProducts}
                >
                  Undo
                </Button>
                <Button variant="outlined" onClick={handleSave} disabled={!modifyTableProducts}>
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </PageHeadline>
        <Box className={`${classes.page_content} ${classes.root} ${isHeaderExpanded ? classes.expanded_content : ''}`}>
          <MaterialReactTable table={table} />
        </Box>
      </Box>
      <ProductManageModal
        open={keywordModal.isOpen}
        productData={keywordModal.data}
        handleClose={() =>
          setKeywordModal({
            isOpen: false,
            data: null,
          })
        }
      />
    </PageWrapper>
  )
}
export default CockpitPage
